<template>
  <base-form-modal
    :show="show"
    :title="title"
    :ok-text="okText"
    :cancel-text="cancelText"

    @show="open"
    @close="$emit('close')"
    @beforeSubmit="function (bool) {beforeSubmitTrigger = bool}"
  >

    <form-modal
      :is-before-submit="beforeSubmitTrigger"
      :service="service"
      v-model="model"
      :show="show"
      ref="form"
      @invoiceClearCorrection="handleInvoiceClearCorrection"
      :task-type="taskType"
    >
    </form-modal>
  </base-form-modal>
</template>
<script>
import FormModalMixin from '../../../../share/modal/FormModalMixin'
import FormModal from '../form/InvoiceEdit'
import api from '../../../../../api'
import _ from 'lodash'
import ErrorNotify from '@/components/share/mixins/ErrorNotify.js'

export default {
  components: {
    FormModal
  },
  mixins: [
    FormModalMixin,
    ErrorNotify
  ],
  props: {
    service: { type: String, default: '' },
    taskNumber: {},
    taskType: {type: String, required: true}
  },
  data () {
    return {
      title: 'Edytuj fakturę',
      okText: 'Edytuj'
    }
  },
  mounted () {
    this.model = _.cloneDeep(this.formData)
  },
  methods: {
    submitForm () {
      let url = this.$isWithClients(this.service) ? `/invoices/${this.model.id}` : `/tasks/invoices/${this.model.id}`
      api.request(this.service, 'put', url, this.createDataToSend())
        .then((response) => {
          this.$notify({
            type: 'success',
            text: 'Zaktualizowano fakturę'
          })
          this.$emit('success')
          this.$emit('close')
          this.$events.$emit('loadInvoice')
        })
        .catch((e) => {
          this.errorNotify(e)
        })
    },
    createDataToSend () {
      let data = {
        amount: this.model.amount,
        description: this.model.description,
        invoiceNumber: this.model.invoiceNumber,
        date: this.model.date,
        delay: this.model.delay || null,
        correction: this.model.correction,
        originalInvoiceNumber: this.model.originalInvoiceNumber
      }
      if (this.$isWithClients(this.service)) {
        data['taskId'] = this.taskNumber
      }
      return data
    },
    handleInvoiceClearCorrection () {
      this.model.originalInvoiceNumber = null
    }
  }
}
</script>
